import {
  StyledDashboardCard,
  CardStack,
  ImageContainer,
  ImageWrapper,
  ServiceImage,
  ContentContainer,
  ServiceTitle,
  ServiceSubTitle,
  ServiceDescription,
} from './styles';

function DashboardCard({ title, description, reverse = false, subTitle, image }) {
  return (
    <StyledDashboardCard elevation={0}>
      <CardStack
        direction={{ xs: 'column', md: reverse ? 'row-reverse' : 'row' }}
        alignItems="center"
      >
        <ImageContainer>
          <ImageWrapper reverse={reverse}>
            <ServiceImage component="img" src={image} alt={title} />
          </ImageWrapper>
        </ImageContainer>

        <ContentContainer reverse={reverse}>
          <ServiceTitle>{title}</ServiceTitle>
          {subTitle && <ServiceSubTitle>{subTitle}</ServiceSubTitle>}
          <ServiceDescription>{description}</ServiceDescription>
        </ContentContainer>
      </CardStack>
    </StyledDashboardCard>
  );
}

export default DashboardCard;
